import { Button, ButtonProps } from 'antd';
import clx from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

const StyledButton = styled(Button)`
  &.ant-btn {
    height: 22px;
    padding: 0px 5px;
    border-radius: 3px;
    font-weight: 600;
    line-height: 1em;

    &.ant-btn-icon-only {
      width: 22px;
      height: 22px;
      padding-inline-start: 0;
      padding-inline-end: 0;
    }
    &.ant-btn-lg.ant-btn-icon-only {
      width: 40px;
      height: 40px;
      padding-inline-start: 0;
      padding-inline-end: 0;
      &.ant-btn-compact-last-item {
        margin-left: -2px;
      }
    }

    &.middle.ant-btn-icon-only {
      width: 32px;
      height: 32px;
      border-width: 1px; // Allineato allo stile Inline dell'editor delle regole
      padding-inline-start: 0;
      padding-inline-end: 0;
    }
  }
`;

export interface IRichTextButtonProps extends ButtonProps {
  isActive?: boolean;
}

export function RichTextButton(props: IRichTextButtonProps) {
  const { isActive, ...otherProps } = props;

  return (
    <StyledButton
      size="small"
      type={props.isActive ? 'primary' : 'link'}
      {...otherProps}
      className={clx(otherProps.className, {
        middle: otherProps.size === 'middle',
      })}
    />
  );
}
